import ExpandMoreIcon from "@mui/icons-material/ExpandMore"
import { Accordion, AccordionDetails, AccordionSummary, Box, Tooltip, Typography } from "@mui/material"
import { SingleService } from "./SingleService"

export const SinglePhase = ({ phase, order, packageExtraInfo }) => {
	const total = phase.services.reduce(
		(acc, service) =>
			acc +
			order.orderlines
				.filter(
					(orderline) => orderline.serviceid === service.serviceid && orderline.phaseid === parseInt(phase.phaseid)
				)
				.reduce((acc, orderline) => acc + orderline.costperunit, service.costperunit),
		0
	)

	return (
		<Box>
			<Accordion sx={{ borderTop: "2px solid black" }}>
				<Tooltip
					title={
						<Box>
							{phase.services.map((service) => (
								<Box
									key={service.serviceid}
									sx={{ display: "flex", flexDirection: "row", justifyContent: "space-between", width: "100%" }}>
									<Typography variant="h5">{service.title}:</Typography>
									<Typography variant="h5" sx={{ ml: 1 }}>
										{order.orderlines
											.filter(
												(orderline) =>
													orderline.serviceid === service.serviceid && orderline.phaseid === parseInt(phase.phaseid)
											)
											.reduce((acc, orderline) => acc + orderline.costperunit, service.costperunit)}{" "}
										€
									</Typography>
								</Box>
							))}
							<Box
								sx={{ display: "flex", flexDirection: "row", justifyContent: "space-between", width: "100%", mt: 1 }}>
								<Typography variant="h4">Total:</Typography>
								<Typography variant="h4">{total} €</Typography>
							</Box>
						</Box>
					}
					followCursor>
					<AccordionSummary expandIcon={<ExpandMoreIcon />}>
						<Typography variant="h3">{phase.title}</Typography>
					</AccordionSummary>
				</Tooltip>
				<AccordionDetails>
					{phase.services.map((service) => (
						<SingleService
							key={service.serviceid}
							service={service}
							order={order}
							phaseId={phase.phaseid}
							packageExtraInfo={packageExtraInfo}
						/>
					))}
				</AccordionDetails>
			</Accordion>
		</Box>
	)
}
